import styled from 'styled-components'
import {Row, Col} from 'antd'

export const StyledRow = styled(Row)`
width:100%;
`
export const StyledCol = styled(Col)`
background: #F9F9F9;
 border: 1px solid #E6E6E6;
 padding:20px;
border-radius: 10px;
margin:10px;
height: fit-content;
`

export const TitleText = styled.div`
font-family: Plus Jakarta Sans;
font-size: 14px;
font-weight: 700;
line-height: 18px;
`
export const BoldText = styled.div`
font-family: Plus Jakarta Sans;
font-size: 12px;
font-weight: 700;
line-height: 18px;
color: #000000
`

export const LightText1 = styled.div`
font-family: Plus Jakarta Sans;
font-size: 12px;
font-weight: 400;
line-height: 18px;
color: #999FAC;
`
export const LightText2 = styled.div`
font-family: Plus Jakarta Sans;
font-size: 12px;
font-weight: 700;
line-height: 18px;
padding-top:10px;
color: #999FAC;
`

